import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { Container, Row, Col, Form, Button, Tab, Tabs } from "react-bootstrap";
import { FaRegTimesCircle } from "react-icons/fa";

import Side from "./Sidebar";
import Top from "./Topbar";
import ErrorAlert from './ErrorAlert';
import SuccessAlert from './SuccessAlert';
import moment from 'moment';
import C from '../lib/Config';
import swal from 'sweetalert';

const dateFormat = 'DD/MM/yyyy';
export default class ApproveCase extends Component {
    constructor(props) {
        super(props);
        this.state = {
            redirectCasePage: false,
            pendingProfileApproval: false,
            patientId: null,
            registrationDate: null,
            caseNo: '',
            firstName: '',
            middleName: '',
            lastName: '',
            emailId: '',
            dob: '',
            genderName: '',
            country: { countryId: null, countryCode: '', countryName: '' },
            phoneNumber1: '',
            doctorId: '',
            doctorName: '',
            instituteDto: { instituteId: null, instituteName: '' },
            height: null,
            weight: null,
            patientComorbidities: '',
            patientAllergies: '',
            anyOngoingTreatment: null,
            successAlertshow: false,
            successAlertclose: false,
            errorAlertshow: false,
            errorAlertclose: false,
            allergies: ''
        }
    }
    componentDidMount() {
        //console.log("props " + JSON.stringify(this.props));
        if (this.props.location && this.props.location.search) {
            let patientId = this.props.location.search.slice(3);
            if (patientId) {
                this.getPatientDetail(patientId);
                this.setState({ patientId: patientId })
            }
        }
    }
    getPatientDetail(patientId) {
        return fetch(C.getUrl() + '/userCase/getPatientDetail/' + patientId)
            .then(res => res.json())
            .then(res => {
                let resObj = res;
                //console.log("patientDetail : " + JSON.stringify(resObj.message));
                this.setPatientDetail(JSON.parse(resObj.message));
            })
            .catch(err => {
                swal({ title: "Warning!", text: "Error : " + err, icon: "error", buttons: false, timer: 2000, });
            });
    }
    setPatientDetail(obj) {
        this.setState({ registrationDate: obj.registrationDate, caseNo: obj.caseId, doctorId: obj.doctor.userId, doctorName: "Dr " + obj.doctor.firstName + " " + obj.doctor.lastName, 
        firstName: obj.firstName, lastName: obj.lastName, emailId: obj.emailId, dob: obj.dob, genderName: obj.genderMstDto.genderName, phoneNumber1: obj.phoneNumber1, 
        instituteDto: obj.instituteDto, height: obj.height + " " + obj.heightUnitDto.unitName, weight: obj.weight + " " + obj.weightUnitDto.unitName });
        if (obj.patientComorbidities) {
            var patientComorbidities = [];
            obj.patientComorbidities.forEach(function (obj) {
                patientComorbidities.push(obj.comorbiditiesDto.comorbiditiesName);
            });
            this.setState({ patientComorbidities: patientComorbidities });
        }
        if (obj.patientAllergies) {
            var patientAllergies = [];
            obj.patientAllergies.forEach(function (obj) {
                patientAllergies.push(obj.allergiesMstDTO.allergiesName);
            });
            console.log(patientAllergies);
            this.setState({ patientAllergies: patientAllergies });
        }
        if(obj.allergies !== undefined
            && obj.allergies != ''){
            this.setState({ allergies: obj.allergies });
        }
    }
    approvePatient() {
        var patientObj = {
            patientID: this.state.patientId,
            approvedByIdUser: {
                userId: JSON.parse(localStorage.getItem("userId"))
            }
        }
        console.log(JSON.stringify(patientObj));
        return fetch(C.getUrl() + '/userCase/approvepatientdet', {
            method: 'POST',
            mode: 'cors',
            body: JSON.stringify(patientObj),
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(res => res.json())
        .then(res => {
            let obj = res;
            let error = obj.subErrors;
            if (error !== null && error !== "") {
                swal({ title: "Warning!", text: "Error : " + error, icon: "error", buttons: false, timer: 2000, });
            } else {
                // this.setState({ successAlertshow: true });
                // setTimeout(() => {
                //     this.setState({ successAlertshow: false })
                // }, 3000)
                swal({ title: "Patient approved succesfully", icon: "success", buttons: false, timer: 2000, });
                this.setState({ redirectCasePage: true });
            }
        })
        .catch(err => {
            // console.log("Error : " + err);
            // this.setState({ errorAlertshow: true });
            // setTimeout(() => {
            //     this.setState({ errorAlertshow: false })
            // }, 3000)
            swal({ title: "Warning!", text: "Error : " + err, icon: "error", buttons: false, timer: 2000, });
        });
    }

    cancelApproveHandler = () => { this.setState({ redirectCasePage: true }); }

    render() {
        if (this.state.redirectCasePage === true) { return <Redirect to='case' /> }
        return (
            <div className="d-flex" id="wrapper">
                {<Side />}
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        {<Top />}
                        <Container fluid>
                            <div className="app-content">
                                <section className="section" id="accordion">
                                    <Row>
                                        <Col lg='12'>
                                            <div className="form-button text-center pull-right mt-2">
                                                <Button variant="secondary" className="btn-primary mr-2" onClick={this.approvePatient.bind(this)}>Accept Case</Button>
                                                <Button variant="secondary" className="btn-primary" onClick={() => this.cancelApproveHandler()}>Cancel</Button>
                                            </div>
                                            <Tabs defaultActiveKey="profile" id="uncontrolled-tab-example">
                                                <Tab eventKey="profile" title="Profile">
                                                    <Container fluid className="p-0 mt-4">
                                                        <Row>
                                                            <Col lg='3'>
                                                                <Form.Group >
                                                                    <Form.Label>Date of Registration</Form.Label>
                                                                    <Form.Control className='readOnlyView' type='text' value={moment(this.state.registrationDate, ['DD/MM/yyyy', 'YYYY-MM-DD', 'MMM DD, YYYY']).format(dateFormat)} onChange={this.handleChange} disabled />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col lg='3'>
                                                                <Form.Group >
                                                                    <Form.Label>Name of the Doctor</Form.Label>
                                                                    <Form.Control className='readOnlyView' type='text' value={this.state.doctorName || ''} onChange={this.handleChange} disabled />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col lg='3'>
                                                                <Form.Group >
                                                                    <Form.Label>Case No.</Form.Label>
                                                                    <Form.Control className='readOnlyView' type='text' value={this.state.caseNo || ''} onChange={this.handleChange} disabled />
                                                                </Form.Group>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col lg='3'>
                                                                <Form.Group >
                                                                    <Form.Label>Salutation</Form.Label>
                                                                    <Form.Control className='readOnlyView' type='text' name='salutation' value='' placeholder='Mr' onChange={this.handleChange} disabled />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col lg='3'>
                                                                <Form.Group >
                                                                    <Form.Label>First Name</Form.Label>
                                                                    <Form.Control className='readOnlyView' type='text' value={this.state.firstName || ''} onChange={this.handleChange} disabled />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col lg='3'>
                                                                <Form.Group >
                                                                    <Form.Label>Middle Name</Form.Label>
                                                                    <Form.Control className='readOnlyView' type='text' value={this.state.middleName || ''} onChange={this.handleChange} disabled />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col lg='3'>
                                                                <Form.Group >
                                                                    <Form.Label>Last Name</Form.Label>
                                                                    <Form.Control className='readOnlyView' type='text' value={this.state.lastName || ''} onChange={this.handleChange} disabled />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col lg='3'>
                                                                <Form.Group >
                                                                    <Form.Label>Email address</Form.Label>
                                                                    <Form.Control className='readOnlyView' type='email' value={this.state.emailId || ''} onChange={this.handleChange} disabled />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col lg='3'>
                                                                <Form.Group >
                                                                    <Form.Label>Date Of Birth</Form.Label>
                                                                    <Form.Control className='readOnlyView' type='text' value={moment(this.state.dob, ['DD/MM/yyyy', 'YYYY-MM-DD', 'MMM DD, YYYY']).format(dateFormat)} onChange={this.handleChange} disabled />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col lg='3'>
                                                                <Form.Group >
                                                                    <Form.Label>Gender</Form.Label>
                                                                    <Form.Control className='readOnlyView' type='email' name='email' value={this.state.genderName || ''} onChange={this.handleChange} disabled />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col lg='3'>
                                                                <Form.Group >
                                                                    <Form.Label>Contact No.</Form.Label>
                                                                    <Form.Control className='readOnlyView' type='text' value={this.state.phoneNumber1 || ''} onChange={this.handleChange} disabled />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col lg='3'>
                                                                <Form.Group >
                                                                    <Form.Label>Height</Form.Label>
                                                                    <Form.Control className='readOnlyView' type='text' value={this.state.height || ''} onChange={this.handleChange} disabled />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col lg='3'>
                                                                <Form.Group >
                                                                    <Form.Label>Weight</Form.Label>
                                                                    <Form.Control className='readOnlyView' type='text' value={this.state.weight || ''} onChange={this.handleChange} disabled />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col lg='3'>
                                                                <Form.Group >
                                                                    <Form.Label>Hospital</Form.Label>
                                                                    <Form.Control className='readOnlyView' type='text' value={this.state.instituteDto.instituteName || ''} onChange={this.handleChange} disabled />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col lg='3'>
                                                                <Form.Group >
                                                                    <Form.Label>Comorbidities</Form.Label>
                                                                    <Form.Control className='readOnlyView' type='text' value={this.state.patientComorbidities || ''} onChange={this.handleChange} disabled />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col lg='3'>
                                                                <Form.Group >
                                                                    <Form.Label>Any ongoing treatment</Form.Label>
                                                                    <Form.Control className='readOnlyView' type='text' onChange={this.handleChange} disabled />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col lg='3'>
                                                                <Form.Group >
                                                                    <Form.Label>Allergies/ Hypersensitivity</Form.Label>
                                                                    <Form.Control className='readOnlyView' type='text' value={this.state.patientAllergies || ''} onChange={this.handleChange} disabled />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col lg='3'>
                                                                <Form.Group >
                                                                    <Form.Label>Other Allergies</Form.Label>
                                                                    <Form.Control className='readOnlyView' type='text' value={this.state.allergies || ''} disabled />
                                                                </Form.Group>
                                                            </Col>
                                                        </Row>
                                                    </Container>
                                                </Tab>
                                                <Tab eventKey="initialAssessment" title="Initial Assessment" disabled></Tab>
                                                <Tab eventKey="report" title="Report" disabled></Tab>
                                                <Tab eventKey="treatmentPlan" title="Treatment Plan" disabled></Tab>
                                                <Tab eventKey="chemotherapy" title="Chemotherapy Sitting" disabled></Tab>
                                            </Tabs>
                                        </Col>
                                    </Row>
                                </section>
                            </div>
                        </Container>
                        {/* <SuccessAlert show={this.state.successAlertshow} alertBody={'Patient approved succesfully.'} />
                        <ErrorAlert show={this.state.errorAlertshow} alertBody={'Something went wrong. Please try again'}/> */}
                    </div>
                </div>
            </div>
        )
    }
}
